import React from 'react';
import $ from 'jquery';
import { store } from 'crazyEditor/redux/store';
import {setCrossSellGalleryItemsIds} from 'MyAccount/ViewDesigns/redux/modules/accountPage';
import {promisesThatNeedToFinishBeforeStartingRevise} from 'crazyEditor/helpers/EbayService';

export const getCrossSellGalleryItemsIds = (sellerId, globalId, itemId) => {
  const promise = $.ajax({
    method: 'GET',
    url: '/application/cross-sell-gallery/get-cross-sell-gallery-items-ids',
    data: {sellerId, globalId, itemId},
  });
  promisesThatNeedToFinishBeforeStartingRevise.push(promise);
  promise.then((result) => {
    if (result.success) {
      store.dispatch(setCrossSellGalleryItemsIds(sellerId, globalId, result.data));
    }
  });
};
